import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { Instagram, Mail, Phone } from "lucide-react";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-brand-ink text-brand-bg mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <span className="font-serif text-4xl tracking-[0.25em]">SPARKLE</span>
          <p className="mt-6 text-sm text-white/60 max-w-sm leading-relaxed font-light">
            {t("footer_about")}
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="overline text-white/40 mb-5">{t("nav_jewelry")}</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/shop?group=jewelry" className="hover:text-white">Ring · Necklace · Earrings</Link></li>
            <li><Link to="/shop?group=jewelry" className="hover:text-white">Bracelet · Anklet</Link></li>
          </ul>
          <p className="overline text-white/40 mt-8 mb-5">{t("nav_clothing")}</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/shop?group=clothing" className="hover:text-white">Shirt · Blouse · Skirt</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="overline text-white/40 mb-5">Əlaqə</p>
          <ul className="space-y-4 text-sm text-white/70">
            <li><a href="tel:+994558855522" className="flex items-center gap-3 hover:text-white"><Phone size={16} strokeWidth={1.5} /> +994 55 885 55 22</a></li>
            <li><a href="mailto:hello@sparkle.az" className="flex items-center gap-3 hover:text-white"><Mail size={16} strokeWidth={1.5} /> hello@sparkle.az</a></li>
            <li><a href="https://instagram.com/sparklebaku" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white" data-testid="footer-instagram"><Instagram size={16} strokeWidth={1.5} /> @sparklebaku</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Sparkle. {t("footer_rights")}</span>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-white/70" data-testid="footer-privacy-link">{t("privacy")}</Link>
            <Link to="/admin/login" className="hover:text-white/70" data-testid="footer-admin-link">{t("nav_admin")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
